<template>
  <div>
    <!----------项目终止招标---------------->
    <project-closed
      :show-stop-tip="showStopTip"
      :show-close-detail-button="showCloseDetailButton"
      @toAbortiveDetail="handleToAbortiveDetail"
    />

    <!----------正常进度条-------------------->
    <div class="step-bar">
      <div v-if="progress.length > 0" class="step">
        <step-component
          :steps="progress"
          :auto="false"
          :active="showStep"
          @selectStep="handleSelectStep"
          @refresh="refresh"
        />
      </div>

      <!---------插槽：展示其他操作------------->
      <slot></slot>

      <!---------变更与异常操作按钮------------>
      <div v-if="showErrorHandleBtn" class="accident flex-align">
        <!--      信息变更-->
        <div v-if="!hideChange">
          <el-dropdown
            v-if="changesDrop.length > 0"
            trigger="click"
            @command="handleDropClick"
          >
            <el-button plain>信息变更</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="item in changesDrop"
                :key="item.name"
                :command="item.pathname"
              >
                {{ item.label }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button v-else plain>信息变更</el-button>
        </div>

        <!--      异常处理-->
        <div class="m-l-9">
          <el-dropdown trigger="click" @command="handleDropClick">
            <el-button type="danger" plain>异常</el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="item in abnormalDropList"
                :key="item.label"
                :command="item.pathname"
              >
                {{ item.label }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectClosed from '@/components/common/ProjectClosed'
import StepComponent from '@/components/common/StepComponent'
import { scrollTo } from '@/utils/scroll-to'
import { workbenchServiceDict } from '@/dictionary/system'
import { mapState } from 'vuex'

export default {
  name: 'StepProgress',

  components: { ProjectClosed, StepComponent },

  props: {
    // 进度条数组
    progress: {
      type: Array,
      required: true
    },

    // 步骤条点击后，是否进行路由跳转
    isRoute: {
      type: Boolean,
      default: true
    },

    // 是否展示信息变更和异常处理按钮
    showErrorHandleBtn: {
      type: Boolean,
      default: true
    },

    // 信息变更下拉菜单数组
    // 参考格式：[{ label: 'xxx', pathname: '' }]
    changesDrop: {
      type: Array,
      default: () => []
    },

    // 隐藏信息变更
    hideChange: {
      type: Boolean,
      default: false
    },

    // 异常的下拉菜单数组
    // 参考格式：[{ label: 'xxx', pathname: '', show: true|false }]
    abnormalDrop: {
      type: Array,
      default: () => []
    },

    // 显示终止招标提示, 默认隐藏
    showStopTip: {
      type: Boolean,
      default: false
    },

    // 显示流标详情按钮，默认隐藏
    showCloseDetailButton: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState('router', ['currentWorkbench']),

    abnormalDropList() {
      return this.abnormalDrop.filter(value => value.show)
    },

    // 代理机构加上Agency
    entrustRouter() {
      if (this.currentWorkbench === workbenchServiceDict.AGENCY.value) {
        return 'Agency'
      }
      return ''
    },

    showStep() {
      return (
        this.progress.findIndex(item =>
          this.$route.name.includes(item.routerName)
        ) + 1
      )
    }
  },

  methods: {
    handleSelectStep(item, index) {
      this.isRoute
        ? this.handleStepClick(item)
        : this.anchorJumps(item.anchorId)
    },

    // 进度条点击事件处理
    handleStepClick(step) {
      this.$emit('stepClick', step)
      if (step.status === 0) {
        this.showStopTip
          ? this.$message.error('项目已关闭')
          : this.$message.info('尚未开始')
      } else {
        const routerName = step.routerName
        if (routerName && routerName !== this.$route.name) {
          if (this.entrustRouter && routerName.includes(this.entrustRouter)) {
            this.$router.replace({ name: routerName })
          } else {
            this.$router.replace({ name: this.entrustRouter + routerName })
          }
        }
      }
    },

    // 锚点跳转
    anchorJumps(target) {
      const to = document.querySelector(`#${target}`).offsetTop
      scrollTo(to, 500)
    },

    // 信息变更和异常的点击处理函数
    handleDropClick(command) {
      if (!command) return

      if (this.entrustRouter && command.includes(this.entrustRouter)) {
        this.$router.push({
          name: command,
          params: { abnormal: 'abnormal' }
        })
      } else {
        this.$router.push({
          name: this.entrustRouter + command,
          params: { abnormal: 'abnormal' }
        })
      }
    },

    // 刷新数据
    refresh() {
      this.$emit('refresh')
    },

    handleToAbortiveDetail() {
      this.$emit('toAbortiveDetail')
    }
  }
}
</script>

<style lang="scss" scoped>
.step-bar {
  background-color: $white-background-color;
  border-radius: pixel-to-rem($n: 10);
  box-sizing: border-box;
  overflow: auto;
  position: relative;
  //height: pixel-to-rem($n: 90);
  margin: 16px 0;
  padding: pixel-to-rem($n: 30) pixel-to-rem($n: 30);
  display: flex;
  align-items: flex-start;

  .step-item {
    color: $third-text-color;
    font-size: pixel-to-rem($n: 20);
    margin-right: pixel-to-rem($n: 30);
    cursor: pointer;
    text-decoration: none;

    &::after {
      display: inline-block;
      content: '';
      height: pixel-to-rem($n: 2);
      width: pixel-to-rem($n: 60);
      background-color: $third-text-color;
      margin-left: pixel-to-rem($n: 30);
    }

    &:last-child::after {
      display: none;
    }

    .step-item__icon {
      margin-right: pixel-to-rem($n: 14);
    }

    img {
      margin-right: pixel-to-rem($n: 14);
      width: pixel-to-rem($n: 24);
    }

    &.active {
      color: $primary-color;

      &::after {
        background-color: $primary-color;
      }
    }

    &.no-line {
      &::after {
        display: none;
      }
    }
  }

  .step {
    flex: 1;
  }

  .accident {
    .step-item {
      color: $text-color;

      .step-item__icon--warning {
        color: $warning-color;
      }

      .step-item__icon--danger {
        color: $danger-color;
      }
    }
  }

  .btn-center {
    margin-top: -5px;
  }
}
</style>
